<template>
  <div>
    <!-- 头部信息 -->
    <header class="flex flex-cross-center">
      <img class="avatar" :src="office.logo" alt onerror />
      <div class="info">
        <h3>{{office.name}}</h3>
        <div class="intro">{{office.introduction}}</div>
      </div>
    </header>

    <!-- 导航栏 -->
    <nav ref="nav">
      <ul class="flex-default">
        <li
          @click="routerPush(li, index)"
          :class="{activeItem: activeIndex == index}"
          v-for="(li, index) in categoryList"
        >
          <span>{{li.name}}</span>
        </li>
      </ul>
    </nav>

    <!-- 列表区 -->
    <section v-if="categoryId && categoryId!=='desc'">
      <ul v-if="list.length > 0">
        <li v-for="article in list" @click="goPath(article)"  class="flex flex-main-justify">
          <!-- 左图右文 -->
          <!-- <div class="flex-default" style="height:100%"> -->
            
            <div class="info" style="width:100%">
              <div :class='["title", "mult_line_ellipsis",article.images && article.images.length>0?"min_height":""]' v-html="article.title"></div>
              <div class="flex date">
                <div class="tag ellipsis" style="justify-content: flex-start;">
                  <span class="tag-red"   v-if="article.type !='subject'" v-html="article.tags"
                  ></span>
                  <span v-html="article.source"></span>
                </div>
                <time>{{getDate(article.date) | dateCompared}}</time>
              </div>
            </div>
             <div
              class="thumbnail"
              :style="{backgroundImage: 'url(' + article.image + ')'}"
              v-if="article.image"
            >
              <i :class="[article.type+'-icon']"></i>
            </div>
          <!-- </div> -->
        </li>
      </ul>
      <div class="desc no-desc" v-else>该锦观号暂未发布内容</div>
      <footer
        @click="getArticles"
        v-if="list.length > 0 && (data.page.next*1 <= data.page.last*1)"
      >加载更多</footer>
    </section>

    <!-- <div class="desc" v-html="office.introduction" v-if="categoryId==='desc'"></div>
    <div class="desc no-desc" v-if="categoryId==='desc' && !office.introduction">暂无简介</div> -->
  </div>
</template>

<script>
import wx from "../services/weChatShare";
import { govUrl } from "constants/project";
export default {
  data() {
    return {
      data: {
        page: {
          next: 1,
          last: 99
        }
      },
      office: {}, //锦观号信息
      categoryList: [],//锦观号-二级分类
      activeIndex: 0,
      list: [],
      categoryId: null
    };
  },

  created() {
    this.getInit(this.$route.params.id);
  },

  mounted() {
    this.$nextTick(() => {
      this._initScroll();
    });
  },

  methods: {
    getInit(id, size = 5) {
      this.$axios.get(`${govUrl}/api/v2/organize/info/${id}`).then(res => {
        const result = res.data;
        if (res.code === 0) {
          this.categoryList = result.categoryList;
          this.office = result;

          // this.categoryList.push({ name: "简介", id: "desc" });

          // 获取第一页文章列表
          let id = result.categoryList[0].id;
          if (id && id !== "desc") {
            this.categoryId = id;
            this.getArticles();
          }

          // 微信分享
          wx(
            {
              title: this.office.name,
              // imgUrl: this.office.logo
            },
            this
          );

          // 存储唤醒的数据
          // this.$store.dispatch("saveData", result);
        }
      });
    },

    getArticles() {
      const pageToken = this.data.page.next * 1;
      const pageLast = this.data.page.last * 1;
      // 最后一页无需加载
      if (pageToken > pageLast) return false;
      // this.$axios.get(`${this.$url}/api/v2/articles/list?categoryId=${this.categoryId}&size=${10}&pageToken=${pageToken}`)
      this.$axios
        .get(
          `${govUrl}/api/v2/articles/list?categoryId=${
            this.categoryId
          }&size=${10}&pageToken=${pageToken}`
        )
        .then(res => {
          const result = res.data;
          if (res.code === 0) {
            this.list = [...this.list, ...result.records];
            this.data.page.next = result.current + 1;
            this.data.page.last = result.pages;
            
          }
        });
    },

    routerPush(item, index) {
      // 重复选择不执行
      if (this.activeIndex === index) return false;
      this.activeIndex = index;
      this.categoryId = item.id;

      // 简介不需要重新调用
      if (item.id === "desc") return false;
      // 重置数据
      this.data = {
        page: {
          next: 1,
          last: 99
        }
      };
      this.list = [];

      this.getArticles();
    },

    getCount(count) {
      let result = 0;
      if (count > 0) {
        result = count;
        if (count > 999999) {
          result = count.substring(0, count.length - 4) + "万";
          if (count > 99999999) {
            result = "过亿";
          }
        }
      }
      return result;
    },

    getDate: date => {
      return date.slice(0, -2) + ":00";
    },

    goPath(article) {
      this.$router.push({
        name: "Detail",
        params: { type: "gov", id: article.articleId }
      });
    },

    _initScroll() {
      this.navScroll = new this.$BScroll(this.$refs.nav, {
        click: true,
        scrollY: false,
        scrollX: true
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~src/stylus/mixin"
@import "~src/stylus/reset";
@import "~src/stylus/list";

header {
  padding: 42px 30px;
  min-height: 204px;
  background: #fff;
  box-sizing: border-box;
  color: #fff;

  .avatar {
    width: 120px;
    height: 120px;
    background: #FDE0E2 url('~images/avatar_jinguan.png') no-repeat 0 0 / 100% 100%;
    border-radius: 999px;
    flex: none;
  }

  .info {
    margin-left: 20px;

    h3 {
      font-size: 36px;
      line-height: 50px;
      font-weight: normal;
      color: #000;
    }

    .intro {
      margin-top: 20px;
      font-size: 26px;
      line-height: 24px;
      color: #666;
    }
  }
}

nav {
  box-shadow: 0px 4px 6px 0px rgba(230, 230, 230, 0.5);
  height: 90px;
  line-height: 90px;

  ul {
    width: -webkit-min-content;
    width: -moz-min-content;
    width: fit-content;
    padding: 0 30px;
    box-sizing: border-box;
    white-space: nowrap;

    li {
      font-size: 28px;
      color: #050505;
      text-align: center;
      margin: 0 34px;
    }
  }
}

.desc {
  margin-top: 40px;
  padding: 0 30px;
  font-size: 28px;
  color: #000;
  line-height: 56px;
}

.no-desc {
  margin-top: 120px;
  text-align: center;
}

.activeItem {
  position: relative;
  color: #E02829;
  // font-weight: bold;
  font-size: 30px;

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    margin-left: -20px;
    width: 40px;
    height: 4px;
    background: #E02829;
  }

  // &:before {
  //   content: '';
  //   position: absolute;
  //   left: -30px;
  //   top: 50%;
  //   margin-top: -1px;
  //   width: 20px;
  //   height: 2px;
  //   background: #FF606C;
  // }

  // &:after {
  //   content: '';
  //   position: absolute;
  //   right: -30px;
  //   top: 50%;
  //   margin-top: -1px;
  //   width: 20px;
  //   height: 2px;
  //   background: #FF606C;
  // }
}
</style>



// WEBPACK FOOTER //
// page-jinguan.vue?5197ecf4